import React, { useEffect } from 'react';
import { CONSTANTS_REQ } from '../../utils/Constants';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { RootState } from '../../rootReducer';
import AddToGroup from './AddToGroup';
import { ENUMS, getColumnSearch, getColumnSearchOption, geti18nText, NyDataTable } from '@nybble/nyreact';
import DeviceEdit from '../device/edit';

const DeviceTable = (props: any) => {
    const { refreshDevice, device } = useSelector((state: RootState) => state.selectedDeviceGroup);

    const setDefaultFilterValue = () => {
        if (props.customerId) {
            return [
                { field: 'active', condition: 'equals_bool', value: 1 },
                { field: 'device_group_id', condition: 'not_equals', value: device },
                { field: 'customer_id', condition: 'equals', value: props.customerId },
            ];
        }
        return [
            { field: 'active', condition: 'equals_bool', value: 1 },
            { field: 'device_group_id', condition: 'not_equals', value: device },
        ];
    };

    return (
        <NyDataTable
            headerTitle={geti18nText('device.table.header')}
            url={CONSTANTS_REQ.DEVICE.LIST}
            setDefaultFilterValue={setDefaultFilterValue}
            showRowSelection={true}
            exportCSV={true}
            scroll={{ x: 800 }}
            addedData={props && props.type ? { type: props.type } : undefined}
            rowSelectionModal={AddToGroup}
            fetchWhenChange={refreshDevice}
            showRecordModal={true}
            modalComponent={DeviceEdit}
            hideNewButton={true}
            columns={[
                {
                    title: geti18nText('device.table.column.id'),
                    dataIndex: 'id',
                    width: '10%',
                    sorter: (a: any, b: any) => {},
                    ...getColumnSearch('number'),
                },
                {
                    title: geti18nText('device.table.column.name'),
                    dataIndex: 'name',
                    sorter: (a: any, b: any) => {},
                    ...getColumnSearch('string'),
                },
                {
                    title: geti18nText('device.table.column.deviceType'),
                    dataIndex: ['deviceType', 'name'],
                    sorter: (a: any, b: any) => {},
                    ...getColumnSearch('string'),
                },
                {
                    title: geti18nText('device.table.column.active'),
                    dataIndex: 'active',
                    width: '10%',
                    render: (text: any, record: { active: any }) => {
                        if (record.active) {
                            return <CheckOutlined style={{ color: 'green' }} />;
                        } else {
                            return <CloseOutlined style={{ color: 'red' }} />;
                        }
                    },
                    ...getColumnSearchOption(ENUMS.ACTIVE(), 'equals_bool', setDefaultFilterValue()[0]['value']),
                    defaultFilteredValue: setDefaultFilterValue(),
                },
            ]}
        />
    );
};

export default DeviceTable;
